import { Color } from 'three';
export const BUTTON_PRIMARY_COLOR = new Color(0x3228C4);
export const BUTTON_PRIMARY_TEXT_COLOR = new Color(0xFFFFFF);
export const BUTTON_BACKGROUND_COLOR = new Color(0x3228C4);
export const BUTTON_HOVER_COLOR = new Color(0x7291D4);
export const BUTTON_HOVER_TEXT_COLOR = new Color(0x12354);
export const PRIMARY_TEXT_COLOR = new Color(0x054373);
export const WINDOW_BORDER_COLOR = new Color(0xB2F6EA);
export const WINDOW_SPACER_COLOR = new Color(0xFFFFFF);
export const WINDOW_BACKGROUND_COLOR = new Color(0xC6E7FC);
export const WINDOW_HEADER_TEXT_BACKGROUND_COLOR = new Color(0x47EC84);
// CHECKBOX =========
export const CHECKBOX_UNCHECKED_BODY_COLOR = new Color(0xB2F6EA);
export const CHECKBOX_CURRENT_BORDER_COLOR = new Color(0x3228C4);
export const CHECKBOX_CURRENT_BODY_COLOR = new Color(0xB2F6EA);
export const CHECKBOX_CHECKED_BODY_COLOR = new Color(0x47EC84);
export const CHECKBOX_CHECKED_TEXT_COLOR = new Color(0xE8F5FF);
export const PROGRESS_BAR_LOADED = new Color(0xFF7F70);
export const PROGRESS_BAR_EMPTY = new Color(0XFFFFFF);
// TASK_PROGRESS =======
export const TASK_PROGRESS_BACKGROUND_COLOR = new Color(0xE9FCF8);
export const MAIN_BACKGROUND_COLOR = new Color(0x3228C4);
// export const MAIN_BACKGROUND_HOVER = new Color(0xbcefe5);
export const MAIN_BACKGROUND_HOVER = new Color(0xff7f70);
// MENU ============
export const MENU_BACKGROUND_COLOR = new Color(0xB3F6EA);
export const SLIDER_FILLED_COLOR = new Color(0x47EC84);
export const SLIDER_PICKER_COLOR = new Color(0x3228C4);
export const SLIDER_PICKER_TEXT_COLOR = new Color(0xFFFFFF);
export const SLIDER_UNFILLED_COLOR = new Color(0xB2F6EA);
export const SLIDER_BORDER_COLOR = new Color(0xFFFFFF);
export const SLIDER_UNFILLED_BORDER_COLOR = new Color(0xFFFFFF);
